export default "__VITE_ASSET__DUW33hiV__"